<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <h3 class="text strat pt-3">Exchange</h3>
    <form (ngSubmit)="onSubmit()" [formGroup]="returnReplaceForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="toBranchSelect">To Branch <span class="text-danger">*</span></label>
          <ng-select labelForId="toBranchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [readonly]="showStockArray" [searchable]="true" placeholder="Select To Branch"
            formControlName="toBranch" class="ng-select-bootstrap" appendTo="body" (change)="onBranchChange()">
          </ng-select>
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3">
          <label for="invoiceNumber">Invoice Number <span class="text-danger">*</span></label>
          <input formControlName="invoiceNumber" id="invoiceNumber" type="text" [readonly]="showStockArray"
            class="form-control default-form-group-border" placeholder="Invoice number" required maxlength="20"
            (input)="onInvoiceInput($event)" (change)="onInvoiceChange($event)" />
          @if (
          returnReplaceForm.get("invoiceNumber")?.invalid &&
          returnReplaceForm.get("invoiceNumber")?.touched
          ) {
          <div>
            @if (returnReplaceForm.get("invoiceNumber")?.errors?.['required']) {
              <small class="text-danger">Please enter invoice number</small>
            }
            @if (returnReplaceForm.get("invoiceNumber")?.errors?.['minlength']) {
              <small class="text-danger">Invoice number must be at least 3 characters</small>
            }
            @if (returnReplaceForm.get("invoiceNumber")?.errors?.['maxlength']) {
              <small class="text-danger">Invoice number must be at most 30 characters</small>
            }
          </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="customerPhoneInput">Phone Number <span class="text-danger">*</span></label>
          <input id="customerPhoneInput" class="form-control default-form-group-border" type="number" formControlName="customerPhone"
            name="customerPhone" required placeholder="Phone number" (input)="onInput($event)"  [readonly]="showStockArray"/>
          @if (
          returnReplaceForm.get("customerPhone")?.invalid &&
          returnReplaceForm.get("customerPhone")?.touched
          ) {
          <div>
            <small class="text-danger">Please enter valid phone number</small>
          </div>
          }
        </div>
      </div>

      @if (showStockArray) {
      <p class="return_stock mt-4 pt-2 border-top">Return Stock</p>
      @for (item of returnStock.controls; track item; let i = $index) {
      <div formArrayName="returnStock" class="stockArray">
        <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'returnTyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'returnTyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
              [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" [readonly]="isFromInvoice" placeholder="Search or Select Tyre Size"
              formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
              (close)="onSizeClose()" (clear)="onSizeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'returnTyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'returnTyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false"
              [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" [readonly]="isFromInvoice" placeholder="Search or Select Tyre Make"
              formControlName="tyreMake" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (change)="selectMake($event, i, true)" (search)="onTyreMakeInputChange($event)"
              (close)="onMakeClose()" (clear)="onMakeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'returnTyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
            <ng-select [labelForId]="'returnTyreModelSelect_' + i" [items]="tyreModelReturnList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
              [clearable]="!isFromInvoice" [searchable]="!isFromInvoice" placeholder="Search or Select Tyre Model"
              formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="isFromInvoice || !returnStock.at(i).get('tyreMake')?.value"
              (scrollToEnd)="scroll(i, 'return')" (search)="onTyreModelInputChange($event, i, 'return')"
              (close)="onReturnModelClose(i)" (clear)="onReturnModelClose(i)">
            </ng-select>
          </div>
          <div class="col-6 col-sm-6 col-md-3">
            <label [attr.for]="'returnQuantityInput_' + i">Total Quantity <span class="text-danger">*</span></label>
            <input [id]="'returnQuantityInput_' + i" type="number" class="form-control default-form-group-border" formControlName="quantity"
              name="quantity" required placeholder="Quantity" appBlockNumberSpecialchars [extraChars]="['.']" />
            @if (
            returnStock.at(i).get("quantity")?.invalid &&
            returnStock.at(i).get("quantity")?.touched
            ) {
            <div>
              @if (returnStock.at(i).get("quantity")?.errors?.['required']) {
                <small class="text-danger">Quantity is required</small>
              }
              @if (returnStock.at(i).get("quantity")?.errors?.['min']) {
                <small class="text-danger">Quantity must be 1</small>
              }
              @if (returnStock.at(i).get("quantity")?.errors?.['max']) {
                <small class="text-danger">Max: {{ returnStock.at(i).get("quantity")?.errors?.['max']?.max }}</small>
              }
            </div>
            }
          </div>
          <div class="col-6 col-sm-6 col-md-3">
            <label [attr.for]="'returnPurchasingPriceInput_' + i">Tyre Price <span class="text-danger">*</span></label>
            <input [id]="'returnPurchasingPriceInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="purchasingPrice"
              name="purchasingPrice" required placeholder="Price" appBlockNumberSpecialchars />
            @if (
            returnStock.at(i).get("purchasingPrice")?.invalid &&
            returnStock.at(i).get("purchasingPrice")?.touched
            ) {
            <div>
              @if (returnStock.at(i).get("purchasingPrice")?.errors?.['max']) {
                <small class="text-danger">Max: {{ returnStock.at(i).get("purchasingPrice")?.errors?.['max']?.max }}</small>
              } @else {
                <small class="text-danger">Price is required</small>
              }
            </div>
            }
          </div>
          <div class="col-6 col-sm-6 col-md-3 d-flex align-items-end justify-content-start gap-1">
              @if (i == returnStock.length - 1 && !isFromInvoice) {
              <button class="btn app-btn-primary" type="button" (click)="addItem(i)">
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
              }
              @if (returnStock.length > 1) {
              <button class="btn btn-danger" type="button" (click)="removeItem(i)">
                <fa-icon [icon]="faTrash"></fa-icon>
              </button>
              }
          </div>
        </div>
      </div>
      }

      <p class="return_stock mt-4">Replace Stock</p>
      @for (item of replaceStock.controls; track item; let i = $index) {
      <div formArrayName="replaceStock" class="stockArray">
        <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'replaceTyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'replaceTyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size"
              formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
              (close)="onSizeClose()" (clear)="onSizeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'replaceTyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'replaceTyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Make"
              formControlName="tyreMake" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (change)="selectMake($event, i, false)" (search)="onTyreMakeInputChange($event)"
              (close)="onMakeClose()" (clear)="onMakeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'replaceTyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
            <ng-select [labelForId]="'replaceTyreModelSelect_' + i" [items]="tyreModelReplaceList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Model"
              formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="!replaceStock.at(i).get('tyreMake')?.value"
              (scrollToEnd)="scroll(i, 'replace')" (search)="onTyreModelInputChange($event, i, 'replace')"
              (close)="onReplaceModelClose(i)" (clear)="onReplaceModelClose(i)">
            </ng-select>
          </div>
          <div class="col-6 col-sm-6 col-md-3">
            <label [attr.for]="'replaceQuantityInput_' + i">Total Quantity <span class="text-danger">*</span></label>
            <input [id]="'replaceQuantityInput_' + i" type="number" class="form-control default-form-group-border" formControlName="quantity"
              name="quantity" required placeholder="Quantity" appBlockNumberSpecialchars [extraChars]="['.']" [appMaxLength]="10" />
            @if (
            replaceStock.at(i).get("quantity")?.invalid &&
            replaceStock.at(i).get("quantity")?.touched
            ) {
            <div>
              @if (replaceStock.at(i).get("quantity")?.errors?.['required']) {
                <small class="text-danger">Quantity is required</small>
              }
              @if (replaceStock.at(i).get("quantity")?.errors?.['min']) {
                <small class="text-danger">Quantity must be 1</small>
              }
            </div>
            }
            @if (
            replaceStock.at(i).get("quantity")?.value &&
            replaceStock.at(i).get("tyresAmount")?.value &&
            +replaceStock.at(i).get("quantity")?.value > +replaceStock.at(i).get("tyresAmount")?.value &&
            replaceStock.at(i).get("quantity")?.touched &&
            replaceStock.at(i).get("tyresAmount")?.touched
            ) {
            <div>
              <small class="text-warning"><span class="fw-bold">Double-check:</span> The quantity is higher than the unit price.</small>
            </div>
            }
          </div>
          <div class="col-6 col-sm-6 col-md-3">
            <label [attr.for]="'replaceTyresAmountInput_' + i">Tyre Price <span class="text-danger">*</span></label>
            <input [id]="'replaceTyresAmountInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="tyresAmount"
              name="tyresAmount" required placeholder="Price" appBlockNumberSpecialchars [appMaxLength]="10"/>
            @if (
            replaceStock.at(i).get("tyresAmount")?.invalid &&
            replaceStock.at(i).get("tyresAmount")?.touched
            ) {
            <div>
              <small class="text-danger">Price is required</small>
            </div>
            }
          </div>
          <div class="col-6 col-sm-6 col-md-3 d-flex align-items-end justify-content-start gap-1">
            @if (i == replaceStock.length - 1) {
            <button class="btn app-btn-primary" type="button" (click)="replaceAddItem(i)">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
            }
            @if (replaceStock.length > 1) {
            <button class="btn btn-danger" type="button" (click)="replaceRemoveItem(i)">
              <fa-icon [icon]="faTrash"></fa-icon>
            </button>
            }
          </div>
        </div>
      </div>
      }

      <!-- Payment Details Section -->
      @if (totalAmount !== 0) {
      <div class="mt-4 pt-2 border-top">
        <h4 class="mb-3">Payment Details</h4>
        <div class="row g-3">
          <div class="col-12 col-sm-6 col-md-3">
            <label for="differenceAmountInput">Total Amount (Difference)</label>
            <input id="differenceAmountInput" type="number" class="form-control default-form-group-border" [value]="totalAmount" readonly disabled />
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label for="paymentModeSelect">Payment Mode <span class="text-danger">*</span></label>
            <ng-select labelForId="paymentModeSelect" [items]="paymentModes" bindLabel="label" bindValue="value" [multiple]="false"
              [clearable]="false" placeholder="Select Payment Mode" formControlName="paymentMode"
              class="ng-select-bootstrap" appendTo="body" (change)="loadPaymentAccounts()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label for="paymentAccountSelect">Payment Account <span class="text-danger">*</span></label>
            <ng-select labelForId="paymentAccountSelect" [items]="paymentAccountsList" bindLabel="accountName" bindValue="_id" [multiple]="false"
              [clearable]="false" placeholder="Select Payment Account" formControlName="paymentAccount"
              [loading]="paymentAccountsLoading" class="ng-select-bootstrap" appendTo="body">
            </ng-select>
          </div>
        </div>
      </div>
      }
      }

      <div class="text-danger pt-3">{{ resMsg }}</div>
      <div class="row pt-3">
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/product-list'" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" [disabled]="(showStockArray ? returnReplaceForm.invalid : (returnReplaceForm.get('toBranch')?.invalid || returnReplaceForm.get('invoiceNumber')?.invalid || returnReplaceForm.get('customerPhone')?.invalid)) || isLoading" class="btn app-btn-primary">
            {{ showStockArray ? 'Submit' : 'Next' }}
            @if (isLoading) {
             <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>
      <br />
    </form>
  </div>
</section>